<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content" >
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" v-if="addType">
        <p class="add-title">添加诊断</p>
        <button class="btn btn-hide"  @click="closeSub">关闭</button>
        
        <div class="write-txt">
          <p class="write-title"><span>*</span>板块名称：</p>
          <div class="write-text">
            <div style="display: inline-block;vertical-align: top;">
              <input type="text" v-model="addObj.name" placeholder="最多输入30个中/英、数字和特殊行号">
            </div>
          </div>

          <div class="label-list secondLabel" v-for="(item,index) in addObj.site_list" :key="index">
            <div class="write-txt">
              <p class="write-title">考点名称：</p>
              <div class="write-text">
                <div style="display: inline-block;vertical-align: top;">
                  <input type="text" v-model="item.name" placeholder="最多输入30个中/英、数字和特殊行号">
                </div>
                <button class="btn btn-add" @click="addTwo()">添加考点</button>
                <button class="btn btn-remove" @click="removeTwo(index)" v-if="index>0">删除</button>
              </div>
            </div>
          </div>
        </div>

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">确定</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加板块与考点</p>
          </div>
          <div class="searchBox clear">
            <div class="search-item">
              <p>板块名称:</p>
              <el-select v-model="obj.name" filterable placeholder="请选择">
                <el-option
                  v-for="item in modelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
            </div>
            <div class="search-item">
              <p>考点名称:</p>
              <el-select v-model="obj.title" filterable placeholder="请选择">
                <el-option
                  v-for="item in SiteList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
        </div>
        <div class="organiza-list">
          <div class="list-title">板块与考点列表</div>
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.model_name">{{item.model_name}}</p>
              <p :title="item.site_name">{{item.site_name}}</p>
              <p :title="item.add_time">{{item.add_time}}</p>
              <p>
                <button title="编辑" class="btn btn-revise" @click="buildShow(item)">编辑</button>
                <button title="删除" class="btn btn-remove" @click="removeShow(item)">删除</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getModelLabelList ,getModelAndSiteList ,saveLabelDetail_model ,saveTopic ,getLabelDetail_model ,delTopic} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "index",
  data() {
    return {
      navId:'9',
      childrenID:'9-4',
      titleList:[
        {id:1,title:'板块名称'},
        {id:2,title:'考点'},
        {id:3,title:'创建时间'},
        {id:4,title:'操作'},
      ],
      dataList:[],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:[],
      totalPage:0,
      removeID:'',
      url:'',
      sortList:[
        {id:1,title:'已开启',value:1},
        {id:2,title:'已隐藏',value:0},
        {id:3,title:'未选择',value:9},
      ],
      loading:false,
      loadTxt:'',

      SiteList:[],
      modelList:[],
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.token = userData.adminToken;
    this.url = this.$refs.navBox.url;
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getList(){
      var that = this;
      try {
        const response = await getModelLabelList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }

      try {
        const response = await getModelAndSiteList({type:1},this.token);
        if(response.code == 200){
          that.modelList = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }

      try {
        const response = await getModelAndSiteList({type:2},this.token);
        if(response.code == 200){
          that.SiteList = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async addSub(){
      var that = this;
      this.addType = 'add';
      this.addObj = {
        name:'',
        site_list:[
          {name:''}
        ]
      }
    },

    async buildShow(e){
      var that = this;
      try {
        const response = await getLabelDetail_model({model_id:e.model_id},this.token);
        if(response.code == 200){
          that.addType = 'edit';
          that.addObj = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    removeShow(e){
      this.removeID = e.tmid;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delTopic({tmid:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.getList();
          that.ModelHide('remove');       
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    ModelHide(type){
      var that = this;
      if(type == 'remove'){
        that.removeType = false;
        taht.removeID = '';
      }
    },

    async saveSub(){
      var that = this;
      if(this.addObj.name == ''){
        that.$message('请填写板块名称！');
        return false;
      };
      try {
          that.addObj.site_list.forEach(function(item,index){
            if(item.name == ''){
                that.$message('考点'+(index+1)+'还未填写');
                throw new Error("EndIterative");
            };
          })
      } catch(e) {
          if (e.message != "EndIterative") {
              throw e;
          } else {
              return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
          }
      };
      try {
        const response = await saveLabelDetail_model(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.addType = '';
      this.addObj = {};
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj={
        page:1,
        rows:10,
      };
      this.addObj={
        
      };
      this.totalPage = 0;
      this.dataList = [];
      this.getList();
    },

    addTwo(index){
      this.addObj.site_list.push({name:''});
    },

    removeTwo(i){
      this.addObj.site_list.splice(i,1);
    }
    
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 4 );
    white-space: nowrap; /* 禁止文本换行 */
    overflow: hidden; /* 隐藏超出范围的内容 */
    text-overflow: ellipsis; /* 使用省略号 */
    padding: 21px 5px;
  }

  .add-title,
  .list-title{
    color: #333333;
    font-size: 22px;
    display: block;
    margin-bottom: 20px;
    position: relative;
    padding-left: 20px;
    line-height: 40px;
  }

  .add-title::before,
  .list-title::before{
    content: '';
    width: 5px;
    height: 22px;
    background-color: #6098F2;
    position: absolute;
    top: 50%;
    transform: translate(0,-50%);
    left: 5px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 334px;
    background-color: #FFFFFF;
    border-radius: 6px;
    display: block;
    padding: 20px;
    box-sizing: border-box;
    border: solid 1px #333333;
    font-size: 16px;
  }

  .MobelBox input{
    height: 50px;
    line-height: 50px;
    width: 500px;
  }

  .MobelBox>>> .el-input{
    font-size: 16px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

  .msgBox .title {
    text-align: center;
    margin-bottom: 50px;
  }

  .MobelBox .write-ai .write-text{
    width: auto;
  }

  .organiza-txt>>>.el-upload{
    width: 100%;
    display: block;
  }

  .organiza-txt>>>.el-button--small span{
    width: 100%;
    text-align: center;
    display: block;
  }

  .organiza-txt>>>.el-button--primary{
    background-color: transparent;
    border: none;
    font-size: 15px;
  }

  .btn-topic-add{
    font-size: 18px;
    color: #6098F2;
    margin: 30px 0 20px;
    display: block;  
    border: solid 1px #6098F2;
    border-radius: 6px;
    padding: 3px 30px;
    box-sizing: border-box;
  }

  .write-text .btn-add{
    display: inline-block;
    vertical-align: top;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    color: #fff;
    border-radius: 6px;
    background-color: #6098F2;
    margin-left: 20px;
    padding: 0 30px;
  }

  .label-list{
    margin-top: 20px;
    margin-left: 160px;
  }

  .write-text  .btn-remove,
  .write-text .btn-add{
    display: inline-block;
    vertical-align: top;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    color: #fff;
    border-radius: 6px;
    background-color: #6098F2;
    margin-left: 20px;
    padding: 0 30px;
  }

  .write-text  .btn-remove{
    background-color: #E2231A;
    background-image: none;
    width: auto;
  }
</style>



// WEBPACK FOOTER //
// src/study/module.vue